import {
  Classes,
  FormGroup,
  Icon,
  Intent,
  RangeSlider,
  Text,
  Colors,
} from '@blueprintjs/core'

export default function SegmentSizeSelector({ segSizes, setSegSizes, selected }) {
  return (
    <FormGroup
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      label={
        <span style={{ fontSize: 13 }}>
          <Icon
            size={14}
            icon="layout-sorted-clusters"
            style={{ marginRight: 3 }}
            className={Classes.TEXT_MUTED}
          />
          Segment Sizes
        </span>
      }
      labelFor="sizes"
      helperText={
        selected.length && segSizes[1] > selected.length ? (
          <Text style={{ color: Colors.RED3, fontWeight: 500 }}>
            Select at least {segSizes[1]} inputs
          </Text>
        ) : null
      }
    >
      <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <RangeSlider
          intent={
            segSizes[1] > selected.length ? Intent.DANGER : Intent.PRIMARY
          }
          id="sizes"
          min={2}
          max={20}
          value={segSizes}
          onChange={range => setSegSizes(range)}
          style={{ width: '100%' }}
        />
      </div>
    </FormGroup>
  )
}
